import React from 'react';
import './Service.css';

import { Link } from 'react-router-dom';
import { renderIcon } from '../../utils';



const Service = ({ service }) => {

  // Destructuring props to extract the necessary details for each service
  const { id, image, title, content } = service;

  return (

    <div className='service-item' key={id}>

      <div className='content'>

        <div className='icon'>{renderIcon(title)}</div> {/* Service Icon */}

        {/* Link to the individual service page 
        <Link
          to={{
            pathname: '/Shop/category/' + title,  // Navigate to the specific service page
          }}
          location = {{service}}  // Passing service details to the linked page
          state= {service}>
          <h3>{title}</h3> 
        </Link>*/}

        <Link to={service.link}>
          <h3>{title}</h3>
        </Link>

        <p>{content}</p> {/* Service Description */}

      </div>

    </div>

  );
};

export default Service;